<template>
  <div
    v-if="menuHasAtLeastOneFilter"
    class="bg-white pt-2 px-2 menu-filter"
  >
    <div class="container-sm">
      <div class="d-flex align-items-center justify-content-center small p-2">
        <div
          class="d-inline"
          v-for="(filter,index) in filters"
          :key="index"
        >
          <a
            v-if="filter.exists"
            v-on:click.prevent="toggleFilter(filter)"
            class="filter-item mx-1 d-inline-block py-1 px-2 rounded text-center"
            href="#"
            v-bind:class="{'filter-selected': filter.selected}"
          ><span class="d-none d-lg-inline filter-longname"><i v-bind:class="filter.iconClass"></i>
              {{ filter.name }}</span>

            <span class="d-lg-none filter-shortname"><i v-bind:class="filter.iconClass"></i>
              {{ filter.shortName }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuMixin from "../../../mixins/menuMixin";
export default {
  data() {
    return {
      rawFilters: {
        /*is_take_out: {
          name: "Takeout",
          shortName: "Takeout",
          iconClass: "fal fa-shopping-bag",
          selected: false,
          exists: false,
          id: 1,
        },*/
        is_special: {
          name: "Special",
          shortName: "Special",
          iconClass: "fal fa-tags",
          selected: false,
          exists: false,
          id: 2,
        },
        is_vegetarian: {
          name: "Vegetarian",
          shortName: "VG",
          iconClass: "fal fa-carrot",
          selected: false,
          exists: false,
        },
        is_vegan: {
          name: "Vegan",
          shortName: "V",
          iconClass: "fal fa-seedling",
          selected: false,
          exists: false,
          id: 3,
        },
        is_gluten_free: {
          name: "Gluten free",
          shortName: "GF",
          iconClass: "fal fa-wheat",
          selected: false,
          exists: false,
          id: 4,
        },
        is_dairy_free: {
          name: "Dairy Free",
          shortName: "DF",
          iconClass: "fal fa-cow",
          selected: false,
          exists: false,
          id: 5,
        },
        is_nut_free: {
          name: "Nut Free",
          shortName: "NF",
          iconClass: "fal fa-acorn",
          selected: false,
          exists: false,
          id: 6,
        },
      },
    };
  },
  methods: {
    toggleFilter: function (f) {
      _.forEach(this.rawFilters, function (fValue, fKey) {
        if (fValue.id == f.id) {
          if (fValue.selected) {
            fValue.selected = false;
          } else {
            fValue.selected = true;
          }
        }
      });
      this.$emit("updateFilters", this.filters);
      this.scrollTo("topOfMenu", 500);
    },
  },
  computed: {
    filters: function () {
      let filters = _.cloneDeep(this.rawFilters);
      //if filter exists on any items then show it
      _.forEach(this.menu.categories, function (cValue, cKey) {
        _.forEach(cValue.items, function (el) {
          _.forEach(filters, function (fValue, fKey) {
            if (el[fKey]) {
              fValue.exists = true;
            }
          });
        });
      });

      return filters;
    },
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  mixins: [menuMixin],
};
</script>

